module.exports = __webpack_public_path__ + "static/media/food5.4748cd50.JPG";